/*
 * Leaflet List Markers v0.1.0 - 2017-11-26
 *
 * Copyright 2017 Stefano Cudini
 * stefano.cudini@gmail.com
 * https://opengeo.tech/
 *
 * Licensed under the MIT license.
 *
 * Demo:
 * https://opengeo.tech/maps/leaflet-list-markers/
 *
 * Source:
 * git@github.com:stefanocudini/leaflet-list-markers.git
 */

(function () {
  L.Control.ListMarkers = L.Control.extend({
    includes: L.version[0] === '1' ? L.Evented.prototype : L.Mixin.Events,

    options: {
      layer: false,
      maxItems: 20,
      collapsed: false,
      label: 'title',
      premier: 'premier',
      recommended: 'recommended',
      certified: 'certified',
      itemIcon: 'icon',
      itemArrow: '&#10148;',
      maxZoom: 9,
      position: 'bottomright',
    },

    initialize: function (options) {
      L.Util.setOptions(this, options);
      this._container = null;
      this._list = null;
      this._layer = this.options.layer || new L.LayerGroup();
    },

    onAdd: function (map) {
      this._map = map;

      var container = (this._container = L.DomUtil.create('div', 'list-markers'));
      this._list = L.DomUtil.create('ul', 'list-markers-ul', container);

      this._initToggle();

      map.on('moveend', this._updateList, this);

      // Build once on add
      this._updateList();

      return container;
    },

    onRemove: function (map) {
      map.off('moveend', this._updateList, this);
      this._container = null;
      this._list = null;
    },

    _createItem: function (layer) {
      var li = L.DomUtil.create('li', 'list-markers-li'),
        a = L.DomUtil.create('div', '', li),
        that = this;

      a.href = layer.options.website;

      L.DomEvent.disableClickPropagation(a).on(
        a,
        'click',
        function () {
          this._moveTo(layer.getLatLng());
        },
        this
      );

      if (layer.options.hasOwnProperty(this.options.label)) {
        let activeClass = '';

        // ✅ FIX: layer._icon may not exist yet; guard it
        const iconSrc =
          layer && layer._icon && layer._icon.currentSrc ? layer._icon.currentSrc : '';

        if (iconSrc && iconSrc.includes('active')) {
          activeClass = 'active pointer-events-none';
        }

        // ✅ Tier label colors:
        // Certified = green (was recommended)
        // Recommended = navy (was certified)
        let installerLabel = '';

        if (layer.options.premier == true) {
          installerLabel =
            "<div class='premier text-micro pt-1' style='color:#F26822;'>Premier Installer</div>";
        } else if (layer.options.certified == true) {
          installerLabel =
            "<div class='certified text-micro pt-1' style='color:#407A62;'>Certified Installer</div>";
        } else if (layer.options.recommended == true) {
          installerLabel =
            "<div class='recommended text-micro pt-1' style='color:#1F2A44;'>Recommended Installer</div>";
        }

        const pinColor = layer.options.premier
          ? '#F26822'
          : layer.options.certified
          ? '#407A62'
          : layer.options.recommended
          ? '#1F2A44'
          : '#1F2A44';

        a.innerHTML =
          '<div onClick="divClick(' +
          layer._leaflet_id +
          ');" class="location flex items-start ' +
          activeClass +
          '" id="' +
          layer._leaflet_id +
          '">' +
          '<svg class="location-pin" style="color:' +
          pinColor +
          ';" width="16" height="22.5" viewBox="0 0 26 37" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M26 13C26 20.1797 21.125 26.8125 13 36.5625C4.875 26.8125 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z" fill="currentColor"/>' +
          '<circle cx="13" cy="13" r="6.5" fill="white"/>' +
          '</svg>' +
          '<div class="pl-4 w-full flex flex-col">' +
          '<h4 class="pb-3">' +
          layer.options.title +
          installerLabel +
          '</h4>' +
          '<div class="link address pb-3">' +
          '<span class="block street">' +
          (layer.options.street || '') +
          '</span>' +
          '<span class="city">' +
          (layer.options.city || '') +
          ', </span>' +
          '<span class="state">' +
          (layer.options.state || '') +
          ', </span>' +
          '<span class="zip">' +
          (layer.options.zip || '') +
          '</span>' +
          '</div>' +
          '<div class="flex justify-between link">' +
          '<div class="phone">' +
          (layer.options.phone || '') +
          '</div>' +
          '<a target="_blank" class="website pointer-events-auto" href="' +
          (layer.options.website || '#') +
          '">Website</a>' +
          '</div>' +
          '</div>' +
          '</div>';
      } else {
        console.log("propertyName '" + this.options.label + "' not found in marker");
      }

      return li;
    },

    _updateList: function () {
      var that = this,
        n = 0;

      if (!this._list) return;

      this._list.innerHTML = '';

      this._layer.eachLayer(function (layer) {
        if (!(layer instanceof L.Marker)) return;

        // ✅ Guard: sometimes markers exist but have no latlng yet
        if (!layer.getLatLng) return;

        // Only show markers in bounds
        if (!that._map.getBounds().contains(layer.getLatLng())) return;

        // ✅ FIX: include maxItems correctly
        if (++n <= that.options.maxItems) {
          that._list.appendChild(that._createItem(layer));
        }
      });
    },

    _initToggle: function () {
      var container = this._container;
      container.setAttribute('aria-haspopup', true);

      if (!L.Browser.touch) {
        L.DomEvent.disableClickPropagation(container);
      } else {
        L.DomEvent.on(container, 'click', L.DomEvent.stopPropagation);
      }

      if (this.options.collapsed) {
        this._collapse();

        if (!L.Browser.android) {
          L.DomEvent.on(container, 'mouseover', this._expand, this).on(
            container,
            'mouseout',
            this._collapse,
            this
          );
        }

        var link = (this._button = L.DomUtil.create('a', 'list-markers-toggle', container));
        link.href = '#';
        link.title = 'List Markers';

        if (L.Browser.touch) {
          L.DomEvent.on(link, 'click', L.DomEvent.stop).on(link, 'click', this._expand, this);
        } else {
          L.DomEvent.on(link, 'focus', this._expand, this);
        }

        this._map.on('click', this._collapse, this);
      }
    },

    _expand: function () {
      this._container.className = this._container.className.replace(' list-markers-collapsed', '');
    },

    _collapse: function () {
      L.DomUtil.addClass(this._container, 'list-markers-collapsed');
    },

    _moveTo: function (latlng) {
      if (this.options.maxZoom)
        this._map.setView(latlng, Math.min(this._map.getZoom(), this.options.maxZoom));
      else this._map.panTo(latlng);
    },
  });

  L.control.listMarkers = function (options) {
    return new L.Control.ListMarkers(options);
  };

  L.Map.addInitHook(function () {
    if (this.options.listMarkersControl) {
      this.listMarkersControl = L.control.listMarkers(this.options.listMarkersControl);
      this.addControl(this.listMarkersControl);
    }
  });
}).call(this);
